import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import { DateInput } from 'semantic-ui-calendar-react'
import { getCorrectLanguageCode } from '~/utils/helpers'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const DateField: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control } = useFormContext()
  const languageStored = localStorage.getItem('i18nextLng')
  const required = !disabled && Boolean(field.fieldRequired)

  return (
    <Controller
      control={control}
      name={`${name}.value`}
      rules={required ? { required: true } : {}}
      render={({ field: f, fieldState }) => (
        <Form.Field required={required} error={Boolean(fieldState.error)}>
          <label><LabelWithInfo label={field.label} info={field.info} required={required} /></label>
          <DateInput
            name={`${name}.value`}
            placeholder={'tt.mm.jjjj'}
            value={f.value || ''}
            disabled={disabled}
            dateFormat='DD.MM.YYYY'
            iconPosition='left'
            closable
            localization={getCorrectLanguageCode(languageStored)}
            autoComplete='new-password'
            onChange={(e, { value }) => f.onChange(value)}
          />
        </Form.Field>
      )}
    />
  )
}

export default DateField
